<template>
  <button
    type="button"
    class="hc-profile-action"
    :class="`hc-profile-action--${variant}`"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <svg class="hc-profile-action__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        v-if="variant === 'edit'"
        d="M4 20h4l10.5-10.5a1.5 1.5 0 000-2.12l-1.88-1.88a1.5 1.5 0 00-2.12 0L4 16v4zM14 6l4 4"
        stroke="currentColor"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        v-else-if="variant === 'add'"
        d="M12 5v14M5 12h14"
        stroke="currentColor"
        stroke-width="1.75"
        stroke-linecap="round"
      />
      <path
        v-else
        d="M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2m2 0v12a2 2 0 01-2 2H8a2 2 0 01-2-2V7h12z"
        stroke="currentColor"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span class="hc-profile-action__label"><slot /></span>
  </button>
</template>

<script>
export default {
  name: 'ProfileActionBtn',
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
      default: 'edit',
      validator: (value) => ['edit', 'add', 'delete'].includes(value),
    },
  },
};
</script>
